namespace TabAurous.Inventory {
    export namespace ConvertToWIPBOMService {
        export const baseUrl = 'Inventory/ConvertToWIPBOM';

        export declare function Create(request: Serenity.SaveRequest<ConvertToWIPBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ConvertToWIPBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ConvertToWIPBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ConvertToWIPBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/ConvertToWIPBOM/Create",
            Update = "Inventory/ConvertToWIPBOM/Update",
            Delete = "Inventory/ConvertToWIPBOM/Delete",
            Retrieve = "Inventory/ConvertToWIPBOM/Retrieve",
            List = "Inventory/ConvertToWIPBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ConvertToWIPBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
